import { Injectable } from '@angular/core';
declare var angular: any;
import { downgradeInjectable } from '@angular/upgrade/static';

import { HttpClient } from '@angular/common/http';
import settings from '../../../../config.json';

@Injectable({
  providedIn: 'root'
})
export class SortingService {

  constructor(private http: HttpClient) { }

  getSorting(contentType) {
    var url: string = settings.configuration.env.apiUrl + 'sort_options/' + contentType;
    return this.http.get(url)
      .toPromise()
      .then((res: any) => {
        return res;
      });
  }

  getFiltering(contentType) {
    var url: string = settings.configuration.env.apiUrl + 'filter_options/' + contentType;
    return this.http.get(url)
      .toPromise()
      .then((res: any) => {
        return res;
      });
  }
  getAudienceList(contentType) {
    var url: string = settings.configuration.env.apiUrl + 'filter_options/' + contentType;
    return this.http.get(url)
      .toPromise()
      .then((res: any) => {
        return res;
      });
  } 
}
angular
  .module('app.core')
  .factory('sortingService', downgradeInjectable(SortingService));